import { useEffect, useState } from 'react';
import useResizeObserver from '@react-hook/resize-observer';
const initialRect = {
  x: undefined,
  y: undefined,
  width: undefined,
  height: undefined,
  top: undefined,
  right: undefined,
  bottom: undefined,
  left: undefined
};
const useBoundingClientRect = ref => {
  const [rect, setRect] = useState(initialRect);
  useEffect(() => {
    if (ref?.current) {
      setRect(ref?.current?.getBoundingClientRect());
    }
  }, [ref]);

  // not using the entry.contentRect because it ignores padding
  useResizeObserver(ref, entry => setRect(entry.target.getBoundingClientRect()));
  return rect;
};
export default useBoundingClientRect;
//# sourceMappingURL=useBoundingClientRect.js.map